export const products = [
    {
        id: 1,
        model: "MacBook Air 2",
        mark: "apple",
        price: 75000,
        imgPrimary: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery3-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1632937845000', 
        imgs: [
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery1-20201110_GEO_MX?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1613174019000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery2-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery3-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1632937845000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery4-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000'
        ,],
        textDesciption: {
            text: "afenfuf n  euafnuenauf efnuenfafjrgs rnugnrsuogn runguaosbguoa runguoanruoga  runaguorngu ragunarugu",
        },
        specs: [
            {
                processor: "Chip M1 de Apple con CPU de 8 núcleos",
                gpu: "GPU de 7 núcleos y Neural Engine de 16 núcleos",
                ram: "8 GB",
                storage: "580 GB",
                keyboard: "Magic Keyboard retroiluminado - Español (Latinoamérica)",
            }
        ],
        security: [
            {
                faceID: true,
                TouchID: false,
            }
        ],
        qualification: 4.5,
        tokens: 5,
        
    },
    {
        id: 2,
        model: "MacBook Air",
        mark: "apple",
        price: 75000,
        imgPrimary: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery1-20201110_GEO_MX?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1613174019000', 
        imgs: [
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery1-20201110_GEO_MX?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1613174019000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery2-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery3-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1632937845000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery4-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000'
        ,],
        textDesciption: {
            text: "afenfuf n  euafnuenauf efnuenfafjrgs rnugnrsuogn runguaosbguoa runguoanruoga  runaguorngu ragunarugu",
        },
        specs: [
            {
                processor: "Chip M1 de Apple con CPU de 8 núcleos",
                gpu: "GPU de 7 núcleos y Neural Engine de 16 núcleos",
                ram: "8 GB",
                storage: "580 GB",
                keyboard: "Magic Keyboard retroiluminado - Español (Latinoamérica)",
            }
        ],
        security: [
            {
                faceID: true,
                TouchID: false,
            }
        ],
        qualification: 4.5,
        tokens: 45,
        
    },
    {
        id: 3,
        model: "MacBook Air",
        mark: "apple",
        price: 75000,
        imgPrimary: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery1-20201110_GEO_MX?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1613174019000', 
        imgs: [
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery1-20201110_GEO_MX?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1613174019000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery2-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery3-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1632937845000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery4-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000'
        ,],
        textDesciption: {
            text: "afenfuf n  euafnuenauf efnuenfafjrgs rnugnrsuogn runguaosbguoa runguoanruoga  runaguorngu ragunarugu",
        },
        specs: [
            {
                processor: "Chip M1 de Apple con CPU de 8 núcleos",
                gpu: "GPU de 7 núcleos y Neural Engine de 16 núcleos",
                ram: "8 GB",
                storage: "580 GB",
                keyboard: "Magic Keyboard retroiluminado - Español (Latinoamérica)",
            }
        ],
        security: [
            {
                faceID: true,
                TouchID: false,
            }
        ],
        qualification: 4.5,
        tokens: 45,
        
    },
    {
        id: 4,
        model: "MacBook Air",
        mark: "apple",
        price: 75000,
        imgPrimary: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery1-20201110_GEO_MX?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1613174019000', 
        imgs: [
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery1-20201110_GEO_MX?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1613174019000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery2-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery3-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1632937845000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery4-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000'
        ,],
        textDesciption: {
            text: "afenfuf n  euafnuenauf efnuenfafjrgs rnugnrsuogn runguaosbguoa runguoanruoga  runaguorngu ragunarugu",
        },
        specs: [
            {
                processor: "Chip M1 de Apple con CPU de 8 núcleos",
                gpu: "GPU de 7 núcleos y Neural Engine de 16 núcleos",
                ram: "8 GB",
                storage: "580 GB",
                keyboard: "Magic Keyboard retroiluminado - Español (Latinoamérica)",
            }
        ],
        security: [
            {
                faceID: true,
                TouchID: false,
            }
        ],
        qualification: 4.5,
        tokens: 45,
        
    },
    {
        id: 5,
        model: "MacBook Air",
        mark: "apple",
        price: 75000,
        imgPrimary: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery1-20201110_GEO_MX?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1613174019000', 
        imgs: [
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery1-20201110_GEO_MX?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1613174019000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery2-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery3-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1632937845000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery4-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000'
        ,],
        textDesciption: {
            text: "afenfuf n  euafnuenauf efnuenfafjrgs rnugnrsuogn runguaosbguoa runguoanruoga  runaguorngu ragunarugu",
        },
        specs: [
            {
                processor: "Chip M1 de Apple con CPU de 8 núcleos",
                gpu: "GPU de 7 núcleos y Neural Engine de 16 núcleos",
                ram: "8 GB",
                storage: "580 GB",
                keyboard: "Magic Keyboard retroiluminado - Español (Latinoamérica)",
            }
        ],
        security: [
            {
                faceID: true,
                TouchID: false,
            }
        ],
        qualification: 4.5,
        tokens: 45,
        
    },
    {
        id: 6,
        model: "MacBook Air",
        price: 75000,
        mark: "apple",
        imgPrimary: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery4-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000', 
        imgs: [
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery1-20201110_GEO_MX?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1613174019000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery2-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery3-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1632937845000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery4-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000'
        ,],
        textDesciption: {
            text: "afenfuf n  euafnuenauf efnuenfafjrgs rnugnrsuogn runguaosbguoa runguoanruoga  runaguorngu ragunarugu",
        },
        specs: [
            {
                processor: "Chip M1 de Apple con CPU de 8 núcleos",
                gpu: "GPU de 7 núcleos y Neural Engine de 16 núcleos",
                ram: "8 GB",
                storage: "580 GB",
                keyboard: "Magic Keyboard retroiluminado - Español (Latinoamérica)",
            }
        ],
        security: [
            {
                faceID: true,
                TouchID: false,
            }
        ],
        qualification: 4.5,
        tokens: 45,
        
    },
    {
        id: 7,
        model: "MacBook Air",
        mark: "apple",
        price: 75000,
        imgPrimary: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery1-20201110_GEO_MX?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1613174019000', 
        imgs: [
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery1-20201110_GEO_MX?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1613174019000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery2-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery3-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1632937845000',
            'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-gallery4-20201110?wid=2000&hei=1536&fmt=jpeg&qlt=95&.v=1603399116000'
        ,],
        textDesciption: {
            text: "afenfuf n  euafnuenauf efnuenfafjrgs rnugnrsuogn runguaosbguoa runguoanruoga  runaguorngu ragunarugu",
        },
        specs: [
            {
                processor: "Chip M1 de Apple con CPU de 8 núcleos",
                gpu: "GPU de 7 núcleos y Neural Engine de 16 núcleos",
                ram: "8 GB",
                storage: "580 GB",
                keyboard: "Magic Keyboard retroiluminado - Español (Latinoamérica)",
            }
        ],
        security: [
            {
                faceID: true,
                TouchID: false,
            }
        ],
        qualification: 4.5,
        tokens: 45,
        
    }
]